<template>
  <!--内容-->
  <div class="bodyboxinvention cursorstyle">
    <div class="applicant" style="margin-top: 20px;">
      <div class="title"><span style="color: red;">*</span> 发明名称：</div>
      <div class="inputbox">
        <el-input placeholder="请输入内容" :disabled="mark == 'see' ? true : false" v-model="formdata.name"></el-input>
      </div>
    </div>
    <div class="buj" style="margin-top: 20px;" v-if="mark != 'see'">
      <div class="jee cursorstyleObjBtn"  @click="onAdd('obligee')" style="display: inline-block;">新增</div>
    </div>
    <div v-for="(item, index) in obligees" :key="'info-1'+ index">
      <div class="hrr1" v-if="index>0">
      </div>
      <div class="boxinp cursorstyleObjBtn" v-if="index>0" style="float: right; margin-top: 2vh;">
        <div @click="onjian('obligee',index)">
          -
        </div>
      </div>
      <div class="PatentNature">
        <div style="display: flex;">
          <div class="title">
            <span style="color: red;">*</span>
            权利人姓名：
          </div>
          <div class="inputbox">
            <el-input placeholder="请输入内容"  :disabled="mark == 'see' ? true : false"  v-model="item.obligee_name"></el-input>
          </div>
        </div>
        <div style="display: flex;">
          <div><span style="color: red;">*</span>权利人联系电话：</div>
          <div class="inputbox">
            <el-input placeholder="请输入内容"  :disabled="mark == 'see' ? true : false"  v-model="item.obligee_phone"></el-input>
          </div>
        </div>
        <div style="display: flex;">
          <div><span style="color: red;">*</span>权利人邮编：</div>
          <div class="inputbox">
            <el-input placeholder="请输入内容"  :disabled="mark == 'see' ? true : false"  v-model="item.obligee_email"></el-input>
          </div>
        </div>

      </div>
      <div class="applicant">
        <div class="title"><span style="color: red;">*</span>权利人地址：</div>
        <!-- <div class="research_project_titlebox">
          <input type="text" placeholder="请输入省份名称" v-model="item.obligee_province">省
        </div>
        <div class="research_project_titlebox">
          <input type="text" placeholder="请输入市名称" v-model="item.obligee_city">市
        </div>
        <div class="research_project_titlebox">
          <input type="text" placeholder="请输入区名称" v-model="item.obligee_district">区
        </div> -->
        <v-distpicker  :disabled="mark == 'see' ? true : false"  @selected="(response)=>{return selected(response,'obligee',index)}"
                      :province="item.obligee_province" :city="item.obligee_city"
                      :area="item.obligee_district"></v-distpicker>
        <div class="research_project_titlebox" style="width:25%;">
          <input type="text"  :disabled="mark == 'see' ? true : false"  placeholder="请输入详细地址" v-model="item.obligee_address">
        </div>
      </div>
      <div class="business">
        <div>
          <div class="title"><span style="color: red;">*</span>身份证复印件：</div>
          <div>
            <el-upload  :disabled="mark == 'see' ? true : false"  :action="GLOBAL.uploadBASE_URL" list-type="picture-card"
                       :on-change="(file, fileList)=>{return handleChange(file, fileList, 'CopyofIDcard',index)}"
                       :on-success="(response)=>{return handleAvatarSuccess(response, 'CopyofIDcard',index)}"
                       :on-remove="(file,fileList)=>{return handleRemove(file,fileList, 'CopyofIDcard',index)}"
                       :file-list="item.obligee_photo"
                       :http-request="(response)=>{return httpRequest(response,'CopyofIDcard',index)}">
              <i slot="default" class="el-icon-plus"></i>
            </el-upload>
          </div>

        </div>

      </div>

    </div>
    <div class="hrr">
    </div>
    <div class="buj" style="margin-top: 20px;" v-if="mark != 'see'">

      <div class="jee cursorstyleObjBtn" @click="onAdd('inventor')" style="display: inline-block;">新增</div>
    </div>
    <div v-for="(item, index) in inventors" :key="index">
      <div class="hrr1" v-if="index>0">
      </div>
      <div class="boxinp cursorstyleObjBtn" v-if="index>0" style="float: right; margin-top: 2vh;">
        <div id="" @click="onjian('inventor',index)">
          -
        </div>
      </div>
      <div class="PatentNature">
        <div style="display: flex;">
          <div class="title"><span style="color: red;">*</span>第{{ userObj.numberfilter(index + 1) }}发明人姓名：</div>
          <div class="inputbox">
            <el-input placeholder="请输入内容"  :disabled="mark == 'see' ? true : false"  v-model="item.inventor_name"></el-input>
          </div>
        </div>
        <div style="display: flex;">
          <div><span style="color: red;">*</span>发明人联系电话：</div>
          <div class="inputbox">
            <el-input placeholder="请输入内容"  :disabled="mark == 'see' ? true : false"  v-model="item.inventor_phone"></el-input>
          </div>
        </div>
        <div style="display: flex;">
          <div><span style="color: red;">*</span>发明人邮箱：</div>
          <div class="inputbox">
            <el-input placeholder="请输入内容"  :disabled="mark == 'see' ? true : false"  v-model="item.inventor_email"></el-input>
          </div>
        </div>
      </div>
<!--      inventor_ID-->
      <div class="PatentNature">
        <div style="display: flex;">
          <div><span style="color: red;">*</span>发明人身份证号：</div>
          <div class="inputbox">
            <el-input placeholder="请输入内容"  :disabled="mark == 'see' ? true : false"  v-model="item.inventor_ID"></el-input>
          </div>
        </div>
      </div>
      <div class="applicant">
        <div class="title"><span style="color: red;">*</span>发明人地址：</div>

        <!-- <div class="research_project_titlebox">
          <input type="text" placeholder="请输入省份名称" v-model="item.inventor_province">省
        </div>
        <div class="research_project_titlebox">
          <input type="text" placeholder="请输入市名称" v-model="item.inventor_city">市
        </div>
        <div class="research_project_titlebox">
          <input type="text" placeholder="请输入区名称" v-model="item.inventor_district">区
        </div> -->
        <v-distpicker  :disabled="mark == 'see' ? true : false"  @selected="(response)=>{return selected(response,'inventor',index)}"
                      :province="item.inventor_province" :city="item.inventor_city"
                      :area="item.inventor_district"></v-distpicker>

        <div class="research_project_titlebox" style="width:25%;">
          <input type="text"  :disabled="mark == 'see' ? true : false"  placeholder="请输入详细地址" v-model="item.inventor_address">
        </div>

      </div>

    </div>
    <div class="hrr">
    </div>
    <div class="PatentNature">
      <div style="display: flex;">
        <div class="title"><span style="color: red;">*</span>申请人姓名：</div>
        <div class="inputbox">
          <el-input placeholder="请输入内容"  :disabled="mark == 'see' ? true : false"  v-model="formdata.applicant_name"></el-input>
        </div>
      </div>
      <div style="display: flex;">
        <div><span style="color: red;">*</span>申请人电活：</div>
        <div class="inputbox">
          <el-input placeholder="请输入内容"  :disabled="mark == 'see' ? true : false"  v-model="formdata.applicant_phone"></el-input>
        </div>
      </div>
      <div style="display: flex;">
        <div><span style="color: red;">*</span>申请人邮箱：</div>
        <div class="inputbox">
          <el-input placeholder="请输入内容"  :disabled="mark == 'see' ? true : false"  v-model="formdata.applicant_email"></el-input>
        </div>
      </div>
    </div>
    <div class="applicant">
      <div class="title"><span style="color: red;">*</span>申请人地址：</div>
      <!-- <div class="research_project_titlebox">
        <input type="text" placeholder="请输入省份名称" v-model="formdata.applicant_province">省
      </div>
      <div class="research_project_titlebox">
        <input type="text" placeholder="请输入市名称" v-model="formdata.applicant_city">市
      </div>
      <div class="research_project_titlebox">
        <input type="text" placeholder="请输入区名称" v-model="formdata.applicant_district">区
      </div> -->
      <v-distpicker  :disabled="mark == 'see' ? true : false"  @selected="(response)=>{return selected(response,'applicant',0)}"
                    :province="formdata.applicant_province" :city="formdata.applicant_city"
                    :area="formdata.applicant_district"></v-distpicker>


      <div class="research_project_titlebox" style="width:25%;">
        <input type="text"  :disabled="mark == 'see' ? true : false"  placeholder="请输入详细地址" v-model="formdata.applicant_address">
      </div>
    </div>
    <div class="hrr">
    </div>
    <div class="PatentNature">
      <div style="display: flex;">
        <div class="title"><span style="color: red;">*</span>联系人姓名：</div>
        <div class="inputbox">
          <el-input placeholder="请输入内容"  :disabled="mark == 'see' ? true : false"  v-model="formdata.contacts_name"></el-input>
        </div>
      </div>
      <div style="display: flex;">
        <div><span style="color: red;">*</span>联系人电活：</div>
        <div class="inputbox">
          <el-input placeholder="请输入内容"  :disabled="mark == 'see' ? true : false"  v-model="formdata.contacts_phone"></el-input>
        </div>
      </div>
      <div style="display: flex;">
        <div><span style="color: red;">*</span>联系人邮箱：</div>
        <div class="inputbox">
          <el-input placeholder="请输入内容"  :disabled="mark == 'see' ? true : false"  v-model="formdata.contacts_email"></el-input>
        </div>
      </div>
    </div>
    <div class="applicant">
      <div class="title"><span style="color: red;">*</span>联系人地址：</div>
      <!-- <div class="research_project_titlebox">
        <input type="text" placeholder="请输入省份名称" v-model="formdata.contacts_province">省
      </div>
      <div class="research_project_titlebox">
        <input type="text" placeholder="请输入市名称" v-model="formdata.contacts_city">市
      </div>
      <div class="research_project_titlebox">
        <input type="text" placeholder="请输入区名称" v-model="formdata.contacts_district">区
      </div> -->
      <v-distpicker  :disabled="mark == 'see' ? true : false"  @selected="(response)=>{return selected(response,'contacts',0)}"
                    :province="formdata.contacts_province" :city="formdata.contacts_city"
                    :area="formdata.contacts_district"></v-distpicker>

      <div class="research_project_titlebox" style="width:25%;">
        <input type="text"  :disabled="mark == 'see' ? true : false"  placeholder="请输入详细地址" v-model="formdata.contacts_address">
      </div>
    </div>
    <div class="hrr">
    </div>

    <div class="technology">
      <div class="title">技术交底书：</div>
      <div class="">
        <div style="margin-bottom: 3px;">
          <el-radio-group  :disabled="mark == 'see' ? true : false"  v-model="formdata.tech_file_type">
            <el-radio :label="1">递交纸质版</el-radio>
            <el-radio :label="2">递交电子版</el-radio>
          </el-radio-group>
        </div>

        <div style="display: flex;" v-if="formdata.tech_file_type == 2">
          <div class="inputbox" v-if="mark != 'see'">
            请上传文件
          </div>
          <el-upload  :disabled="mark == 'see' ? true : false"  class="upload-demo" :action="GLOBAL.uploadBASE_URL"
                     :on-change="(file, fileList)=>{return handleChange(file, fileList, 'TechnicalDisclosure')}"
                     :on-success="(response)=>{return handleAvatarSuccess(response, 'TechnicalDisclosure')}"
                     :on-remove="(file,fileList)=>{return handleRemove(file,fileList, 'TechnicalDisclosure')}"
                     :file-list="TechnicalDisclosure"
                     :http-request="(response)=>{return httpRequest(response,'TechnicalDisclosure')}">
            <div class="enclosure" v-if="mark != 'see'">
              上传附件
              <img src="@/assets/img/文件.png" alt="">
            </div>

          </el-upload>
          <div class="enclosure1" v-if="mark != 'see'">
            <span><a :href="GLOBAL.jiShuJiaoDi" download="技术交底书.docx">下载模板️</a></span>
            <i class="el-icon-download"></i>
            <span style="line-height: 28px; color: red; margin-left: 5px;" >（注:只申请外观设计专利无需上传技术交底书模板，上传100字左右word格式专利说明即可）</span>


          </div>
        </div>
      </div>
    </div>
    <div class="technology">
      <div class="title">承诺书：</div>
      <div class="inputbox" v-if="mark != 'see'">
        请上传文件
      </div>
      <el-upload  :disabled="mark == 'see' ? true : false"  class="upload-demo" :action="GLOBAL.uploadBASE_URL"
                 :on-change="(file, fileList)=>{return handleChange(file, fileList, 'promise_file')}"
                 :on-success="(response)=>{return handleAvatarSuccess(response, 'promise_file')}"
                 :on-remove="(file,fileList)=>{return handleRemove(file,fileList, 'promise_file')}"
                 :file-list="promise_file" :http-request="(response)=>{return httpRequest(response,'promise_file')}">
        <div class="enclosure" v-if="mark != 'see'">
          上传附件
          <img src="@/assets/img/文件.png" alt="">
        </div>

      </el-upload>
<!--      <div class="enclosure1" v-if="mark != 'see'">-->
<!--        <span @click="promise_fileDownload">下载模板️</span>-->
<!--        <i class="el-icon-download"></i>-->
<!--      </div>-->
      <div class="enclosure1" v-if="mark != 'see'">
        <span><a :href="GLOBAL.qiTaJiGochengNuo(this.userObj.info().nature)" download="技术交底书.docx">下载模板️</a></span>
        <i class="el-icon-download"></i>
      </div>

    </div>

    <div class="technology">
      <div>是否进行过知识产权保护：</div>
      <div class="">
        <el-radio-group :disabled="mark == 'see' ? true : false" v-model="formdata.is_ip_protected">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </div>
    </div>

    <div class="technology" v-if="formdata.is_ip_protected === 1">
      <div>已保护知识产权类型：</div>
      <div class="">
        <el-checkbox-group :disabled="mark == 'see' ? true : false" v-model="protected_ip_type" @change="handleCheckAllChange">
          <el-checkbox label="1">专利</el-checkbox>
          <el-checkbox label="2">商标</el-checkbox>
          <el-checkbox label="3">软件著作权（版权）</el-checkbox>
          <el-checkbox label="4">其它</el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="research_project_titlebox" style="margin-left: 3vw;">
        <input type="text" :disabled="mark == 'see' ? true : false" placeholder="输入知识产权类型" v-model="formdata.protected_ip_desc">
      </div>
      <span style="line-height: 28px; color: red; margin-left: 5px;">(注：可多选)</span>
    </div>
    <div class="technology">
      <div class="title">知识产权方式：</div>
      <div class="">
        <el-radio-group :disabled="mark == 'see' ? true : false" v-model="formdata.ip_mode">
          <el-radio :label="1">保护</el-radio>
          <el-radio :label="2">转化</el-radio>
          <el-radio :label="3">保护+转化</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="technology" v-if="formdata.ip_mode == 2|| formdata.ip_mode == 3">
      <div class="title">收益比例确认书：</div>
      <div class="inputbox" v-if="mark != 'see'">
        请上传文件
      </div>
      <el-upload :disabled="mark == 'see' ? true : false" class="upload-demo" :action="GLOBAL.uploadBASE_URL"
                 :on-change="(file, fileList)=>{return handleChange(file, fileList, 'powerOfAttorney')}"
                 :on-success="(response)=>{return handleAvatarSuccess(response, 'powerOfAttorney')}"
                 :on-remove="(file,fileList)=>{return handleRemove(file,fileList, 'powerOfAttorney')}"
                 :file-list="powerOfAttorney"
                 :http-request="(response)=>{return httpRequest(response,'powerOfAttorney')}">
        <div class="enclosure" v-if="mark != 'see'">
          上传附件
          <img src="@/assets/img/文件.png" alt="">
        </div>
      </el-upload>
      <div class="enclosure1" v-if="mark != 'see'">
        <span><a :href="GLOBAL.shouYiBiLI" download="收益比例确认书">下载模板</a></span>
        <i class="el-icon-download"></i>
      </div>
    </div>
    <div class="technology" v-if="formdata.ip_mode == 2|| formdata.ip_mode == 3">
      <div class="title">公证书：</div>
      <div class="inputbox" v-if="mark != 'see'">
        请上传文件
      </div>
      <el-upload :disabled="mark == 'see' ? true : false" class="upload-demo" :action="GLOBAL.uploadBASE_URL"
                 :on-change="(file, fileList)=>{return handleChange(file, fileList, 'notarization_file')}"
                 :on-success="(response)=>{return handleAvatarSuccess(response, 'notarization_file')}"
                 :on-remove="(file,fileList)=>{return handleRemove(file,fileList, 'notarization_file')}"
                 :file-list="notarization_file"
                 :http-request="(response)=>{return httpRequest(response,'notarization_file')}">
        <div class="enclosure" v-if="mark != 'see'">
          上传附件
          <img src="@/assets/img/文件.png" alt="">
        </div>
<!--        <div class="enclosure1">-->
<!--          <span>下载模板️</span>-->
<!--          <i class="el-icon-download"></i>-->
<!--        </div>-->
        <span style="line-height: 28px; color: red; margin-left: 5px;">（注：请将“收益比例确认书”公证后进行上传）</span>

      </el-upload>
    </div>
    <div class="technology">
      <div class="title">科研经费支持：</div>
      <div class="">
        <el-radio-group :disabled="mark == 'see' ? true : false" v-model="formdata.is_research_funds_support">
          <el-radio :label="0">是</el-radio>
          <el-radio :label="1">否</el-radio>
        </el-radio-group>
      </div>
      <div class="research_project_titlebox" style="margin-left: 3vw;">
        <input type="text" :disabled="mark == 'see' ? true : false" placeholder="输入科研课题/项目名称" v-model="formdata.research_project_title">
      </div>
    </div>

    <div class="technology">
      <div class="title">其他附件：</div>
      <div class="inputbox" v-if="mark != 'see'">
        请上传文件
      </div>
      <el-upload :disabled="mark == 'see' ? true : false" class="upload-demo" :action="GLOBAL.uploadBASE_URL"
                 :on-change="(file, fileList)=>{return handleChange(file, fileList, 'other_file')}"
                 :on-success="(response)=>{return handleAvatarSuccess(response, 'other_file')}"
                 :on-remove="(file,fileList)=>{return handleRemove(file,fileList, 'other_file')}"
                 :file-list="other_file"
                 :http-request="(response)=>{return httpRequest(response,'other_file')}">
        <div class="enclosure" v-if="mark != 'see'">
          上传附件
          <img src="@/assets/img/文件.png" alt="">
        </div>


      </el-upload>
      <span style="line-height: 28px; color: red; margin-left: 5px;">(注：可上传word文字介绍，视频简介，ppt，PDF，不限格式)</span>
    </div>
    <!-- 外观 -->
    <div class="business" v-if="isInArray(this.checkList,'3')">
      <div>
        <div>
          <div class="title"><span style="color: red;">*</span>设计图片：</div>
        </div>
        <div>
          <el-upload  :disabled="mark == 'see' ? true : false" :action="GLOBAL.uploadBASE_URL" list-type="picture-card"
                     :on-change="(file, fileList)=>{return handleChange(file, fileList, 'DesignPicture')}"
                     :on-success="(response)=>{return handleAvatarSuccess(response, 'DesignPicture')}"
                     :on-remove="(file,fileList)=>{return handleRemove(file, fileList, 'DesignPicture')}"
                     :file-list="DesignPicture"
                     :http-request="(response)=>{return httpRequest(response,'DesignPicture')}">
            <i slot="default" class="el-icon-plus"></i>
          </el-upload>
        </div>
        <span>（设计图片提交彩色和黑白图片各一张）</span>
      </div>
    </div>

    <div v-if="formdata.create_type == 2 ||formdata.create_type == 3 ||this.$route.query.create_type == 2">
      <div class="PatentNature">
        <div style="display: flex;">
          <div class="title">申请号：</div>
          <div class="inputbox">
            <el-input  :disabled="mark == 'see' ? true : false" v-model="formdata.apply_serial_no" placeholder="请输入内容"></el-input>
          </div>
        </div>
      </div>
      <div class="PatentNature">
        <div style="display: flex;">
          <div class="title">专利申请日：</div>
          <div class="inputbox">
            <el-date-picker  :disabled="mark == 'see' ? true : false" v-model="formdata.apply_time" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date"
                            placeholder="选择日期">
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="technology">
        <div class="title">是否授权：</div>
        <div class="">
          <el-radio-group  :disabled="mark == 'see' ? true : false" v-model="formdata.is_authenticated">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="PatentNature">
        <div style="display: flex;">
          <div class="title">授权专利名称：</div>
          <div class="inputbox">
            <el-input  :disabled="mark == 'see' ? true : false" v-model="formdata.authenticated_name" placeholder="请输入内容"></el-input>
          </div>
        </div>
      </div>
      <div class="PatentNature">
        <div style="display: flex;">
          <div class="title">专利权号：</div>
          <div class="inputbox">
            <el-input  :disabled="mark == 'see' ? true : false" v-model="formdata.serial_no" placeholder="请输入内容"></el-input>
          </div>
        </div>
      </div>
      <div class="PatentNature">
        <div style="display: flex;">
          <div class="title">证书号：</div>
          <div class="inputbox">
            <el-input  :disabled="mark == 'see' ? true : false" v-model="formdata.certificate_serial_no" placeholder="请输入内容"></el-input>
          </div>
        </div>
      </div>
      <div class="PatentNature">
        <div style="display: flex;">
          <div class="title">授权公告号：</div>
          <div class="inputbox">
            <el-input  :disabled="mark == 'see' ? true : false" v-model="formdata.authenticated_serial_no" placeholder="请输入内容"></el-input>
          </div>
        </div>
      </div>
      <div class="PatentNature">
        <div style="display: flex;">
          <div class="title">授权公告日：</div>
          <div class="inputbox">
            <el-date-picker  :disabled="mark == 'see' ? true : false" v-model="formdata.authenticated_time" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                            type="date" placeholder="选择日期">
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="PatentNature">
        <div style="display: flex;">
          <div class="title">过期日期：</div>
          <div class="inputbox">
            <el-date-picker  :disabled="mark == 'see' ? true : false" v-model="formdata.expire_time" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date"
                            placeholder="选择日期">
            </el-date-picker>
          </div>
        </div>
      </div>
    </div>




    <div class="btnbox">
      <div class="bcbtn cursorstyleObjBtn" v-if="!this.$route.query.mark && this.patentIDlength == null"
           @click="SubmitBtn('add','patent')">
        <span>保存 </span>
      </div>
      <div class="tjbtn cursorstyleObjBtn" v-if="!this.$route.query.mark && this.patentIDlength == null" @click="SubmitBtn('add')">
        <span>提交 </span>
      </div>

<!--      -->
<!--      <div class="bcbtn" v-if="this.$route.query.mark=='edit'||this.patentIDlength>0"-->
<!--           @click="SubmitBtn('edit','patent')">-->
<!--        <span>保存</span>-->
<!--      </div>-->
      <div class="tjbtn cursorstyleObjBtn" v-if="this.$route.query.mark=='edit'||this.patentIDlength>0" @click="SubmitBtn('edit')">
        <span>提交</span>
      </div>
    </div>


  </div>
</template>

<script>
import VDistpicker from 'v-distpicker' //引入省市区三级联动插件
import {
  AddPatentInterface,
  GetlistPatentInterface,
  modifyPatentInterface,
  GetObjPatentInterface,
  upload
} from '@/api/ApplicationManagement.js'
// 省市区选择器
export default {
  props: {
    templateTpl: ''
  },
  data() {
    return {
      mark:'',
      // 身份证复印件
      CopyofIDcard: [],
      // 设计图片
      DesignPicture: [],
      // 委托书
      powerOfAttorney: [],
      //公正书
      notarization_file:[],
      // 技术交底书
      TechnicalDisclosure: [],

      inventor: [{
        // 发明人姓名
        "inventor_name": "",
        // 发明联系人
        "inventor_phone": '',
        // 发明人邮政编码
        "inventor_email": '',
        // 发明人地址
        "inventor_address": '',
        inventor_ID:'',
        // 发明图
        "inventor_photo": [],
        inventor_province: '',
            inventor_city: '',
            inventor_district: ''
      }],
      inventors: [{
        // 发明人姓名
        "inventor_name": "",
        // 发明联系人
        "inventor_phone": '',
        // 发明人邮政编码
        "inventor_email": '',
        // 发明人地址
        "inventor_address": '',
        // 发明图
        "inventor_photo": [],
        inventor_ID:'',
        inventor_province: '',
            inventor_city: '',
            inventor_district: ''
      }],
      obligee: [{
        // 权利人名字
        "obligee_name": "",
        // 权利人联系人
        "obligee_phone": '',
        // 权利人邮编
        "obligee_email": '',
        // 权利人地址
        "obligee_address": '',
        // 权利人图
        "obligee_photo": [],
        obligee_province: '',
        obligee_city: '',
        obligee_district: ''
      }],
      obligees: [{
        // 权利人名字
        "obligee_name": "",
        // 权利人联系人
        "obligee_phone": '',
        // 权利人邮编
        "obligee_email": '',
        // 权利人地址
        "obligee_address": '',
        // 权利人图
        "obligee_photo": [],
        obligee_province: '',
        obligee_city: '',
        obligee_district: ''
      }],
      // 承诺书
      promise_file: [],
      // 其他附件
      other_file: [],
      // 类型
      protected_ip_type: [],
      checkList: ['1'],
      formdata: {
        "name": "",
        "type": '1',
        // 描述
        "desc": "",
        "status": '1',
        "nature": '1',
        // 创建方式
        "create_type": 1,
        // 身份证
        "obligee_name": "",
        // 权利人联系人
        "obligee_phone": '',
        // 权利人邮编
        "obligee_email": '',
        // 权利人地址
        "obligee_address": '',
        // 权利人图
        "obligee_photo": "",
        "obligee": [],
        // 发明人姓名
        "inventor_name": "",
        // 发明联系人
        "inventor_phone": '',
        // 发明人邮政编码
        "inventor_email": '',
        // 发明人地址
        "inventor_address": '',
        // 发明图
        "inventor_photo": '',
        "inventor": [],
        // 申请人姓名
        "applicant_name": "",
        // 申请人联络人
        "applicant_phone": '',
        // 申请人邮政编码
        "applicant_email": '',
        // 申请人地址
        "applicant_address": '',
        // 申请人照片
        "applicant_photo": '',
        // 申请人区
        "applicant_district": '',
        //申请人 市
        "applicant_city": '',
        //申请人省
        "applicant_province": '',
        // 联系人名字
        "contacts_name": '',
        // 联系人电话
        "contacts_phone": '',
        //联系人 邮箱
        "contacts_email": '',
        // 联系人地址
        "contacts_address": '',
        // 联系人区
        "contacts_district": '',
        //联系人 市
        "contacts_city": '',
        //联系人省
        "contacts_province": '',
        // // 技术交底书性质 1:纸质版 2:电子版
        // "tech_file_type": null,
        // // 承诺书
        // "promise_file": '',
        // // 知识产权方式
        // "ip_mode": '',
        // // 是否进行过知识产权保护
        // "is_ip_protected": '',
        // // 已保护知识产权类型
        // "protected_ip_type": '',
        // // 已保护知识产权类型其他说明
        // "protected_ip_desc": '',
        // // 经费
        // "is_research_funds_support": '',
        // // 科研项目名称
        // "research_project_title": '',
        // // 其他附件
        // "other_file": '',
        //公正书
        notarization_file:'',

      },
      patentIDlength: null

    }
  },
  components: {VDistpicker},
  watch: {
    templateTpl: {
      deep: true, //深度监听设置为 true
      handler: function (newV, oldV) {
        if (newV) {
          this.checkList = newV
          if (newV) {
            this.formdata.type = newV.join(',')
          }
        }

      }
    }
  },
  mounted() {

    this.mark = this.$route.query.mark
    if(this.formdata.nature == 3 || this.userObj.info().nature == 3 ){
      this.formdata.nature = 3
      this.obligees[0].obligee_name = '首都医科大学附属北京中医医院'
      this.obligee[0].obligee_name = '首都医科大学附属北京中医医院'
      this.obligees[0].obligee_district = '3'
      this.obligee[0].obligee_district = '3'
      this.obligees[0].obligee_city = '2'
      this.obligee[0].obligee_city = '2'
      this.obligees[0].obligee_province = '1'
      this.obligee[0].obligee_province = '1'
      this.obligees[0].obligee_photo = '0'
      this.obligee[0].obligee_photo = '0'
      this.obligees[0].obligee_email = '0'
      this.obligee[0].obligee_email = '0'
    }
    // 1个人， 2其他组织
    // this.nature = this.userObj.info().nature
    this.formdata.nature = this.userObj.info().nature


    if (this.$route.query.create_type == 2) {
      this.formdata.create_type = 2
    } else {
      this.formdata.create_type = 1
    }


    if (localStorage.getItem('patentID')) {
      this.patentIDlength = localStorage.getItem('patentID').length
    }
    let mark = this.$route.query.mark
    // 查看
    if (mark == "see" || mark == "edit" || localStorage.getItem('patentID')) {
      if (this.$route.query.ids) {
        this.GetlistPatent(this.$route.query.ids)
      } else if (localStorage.getItem('patentID').length > 0) {
        this.GetlistPatent(localStorage.getItem('patentID'))
      }
    }

  },
  methods: {

    //下载承诺书
    promise_fileDownload(){
      this.$alert('<strong><a href="./export/shouYiBiLi.docx" download="下载模板1️.docx">下载模板1️</a><br/><a href="./export/shouYiBiLi.docx" download="下载模板2️.docx">下载模板2️</a> </strong>', '承诺书模版', {
        dangerouslyUseHTMLString: true
      });
    },
    // 省市区
    selected(data, VDisType, index) {
      let dataList = []
      dataList.push(data)
      if (VDisType == 'obligee') {
        dataList.forEach(val => {
          this.obligees[index].obligee_province = val.province.value;
          this.obligees[index].obligee_city = val.city.value;
          this.obligees[index].obligee_district = val.area.value;
        })
      } else if (VDisType == 'inventor') {
        dataList.forEach(val => {
          this.inventors[index].inventor_province = val.province.value;
          this.inventors[index].inventor_city = val.city.value;
          this.inventors[index].inventor_district = val.area.value;
        })
      }
      else if (VDisType == 'applicant') {
        // 申请人
        this.formdata.applicant_province = data.province.value
        this.formdata.applicant_city = data.city.value
        this.formdata.applicant_district = data.area.value
      } else if (VDisType == 'contacts') {
        // 申请人
        this.formdata.contacts_province = data.province.value
        this.formdata.contacts_city = data.city.value
        this.formdata.contacts_district = data.area.value
      }

    },
    // 专利新增和发明人新增
    onAdd(value) {
      switch (value) {
        case 'obligee':
          (() => {
            let datas = JSON.parse(JSON.stringify(this.obligee))
            this.obligees = [...this.obligees, ...datas]
          })()
          break
        case 'inventor':
          (() => {
            let shengdata = JSON.parse(JSON.stringify(this.inventor))
            this.inventors = [...this.inventors, ...shengdata]
          })()
          break
      }
    },
    onjian(value, index) {
      switch (value) {
        case 'obligee':
          (() => {
            this.obligees = this.obligees.filter((item, indexs) => indexs != index)
          })()
          break
        case 'inventor':
          (() => {
            this.inventors = this.inventors.filter((item, indexs) => indexs != index)
          })()
          break
      }
    },
    httpRequest(param, type, index) {
      let fileObj = param.file // 相当于input里取得的files
      let fd = new FormData() // FormData 对象
      fd.append('files', fileObj) // 文件对象
      this.uploadInterface(fd, type, fileObj, index)
    },

    handleChange(file, fileList, type) {
    },
    // 上传成功
    handleAvatarSuccess(res, type) {
    },
    // 上传删除
    handleRemove(file, fileList, type, index) {
      // 身份证复印件
      if (type == 'CopyofIDcard') {
        this.obligees[index].obligee_photo = fileList
      }
      // 设计图片
      else if (type == 'DesignPicture') {
        this.DesignPicture = fileList
      }
      // 委托书 powerOfAttorney
      else if (type == 'powerOfAttorney') {
        this.powerOfAttorney = fileList
      }
      //公正书
      // notarization_file:[],
      else if (type == 'notarization_file') {
        this.notarization_file = fileList
      }
      // TechnicalDisclosure 技术交底书
      else if (type == 'TechnicalDisclosure') {
        this.TechnicalDisclosure = fileList
      }

      // 承诺书promise_file
      else if (type == 'promise_file') {
        this.promise_file = fileList
      }
      // other_file 其他附件
      else if (type == 'other_file') {
        this.other_file = fileList
      }
    },
    //修改提交添加专利
    async modifyPatent(vlaue) {
      let obj = this.formdata
      if (vlaue == 'patent') {
        obj.status = 2
      } else {
        obj.status = 3
      }
      let res = await modifyPatentInterface(obj)
      if (res.code == "00000") {
        if (vlaue == 'patent') {
          this.$message.success('保存成功')
          this.$router.push('./patentSeeMore')
        } else {
          localStorage.setItem('patentID', '')
          this.$message.success('提交成功')
          this.$router.push('./patentSeeMore')
        }
      }
    },
    //提交添加专利
    async addPatent(vlaue) {
      let obj = this.formdata
      if (vlaue == 'patent') {
        obj.status = 2
      } else {
        obj.status = 3
      }
      if(obj.obligee[0]){
        obj.first_obligee = obj.obligee[0].obligee_name
      }else {
        obj.first_obligee =''
      }
      let res = await AddPatentInterface(obj)
      if (res.code == "00000") {
        if (vlaue == 'patent') {
          // localStorage.setItem('patentID', res.data.id)
          localStorage.setItem('patentID', '')
          this.$message.success('保存成功')
          this.$router.push('./patentSeeMore')
        } else {
          this.$message.success('提交成功')
          this.$router.push('./patentSeeMore')

        }

      }
    },
    //获取详情
    async GetlistPatent(value) {
      let obj = {
        id: value
      }
      let res = await GetObjPatentInterface(obj)
      if (res.code === "00000") {
        this.formdata = res.data
        this.$emit("dataNature", {
          nature: res.data.nature,
          checkList: res.data.type
        })
        if (res.data.type.legth > 2) {

          this.checkList = res.data.type.split(',')
        }
        // 删除无用数据
        if (this.formdata.create_time) {
          this.$delete(this.formdata, 'create_time')
        } else if (this.formdata.update_time) {
          this.$delete(this.formdata, 'update_time')
        } else if (this.formdata.create_by) {
          this.$delete(this.formdata, 'create_by')
        } else if (this.formdata.update_by) {
          this.$delete(this.formdata, 'update_by')
        } else if (this.formdata.status_txt) {
          this.$delete(this.formdata, 'status_txt')
        }
        //
        this.obligees = res.data.obligee
        this.inventors = res.data.inventor
        // `proxy_file`  '代理委托书url',
        if (res.data.proxy_file != '') {
          this.powerOfAttorney = res.data.proxy_file
        }
        //公正书
        // notarization_file:[],
        if (res.data.notarization_file != '') {
          this.notarization_file = res.data.proxy_file
        }
        //   `tech_file`  '技术交底书url',
        if (res.data.tech_file != '') {
          this.TechnicalDisclosure = res.data.tech_file
        }

        //   `design_pics`  '设计图片url',
        if (res.data.design_pics != '') {
          this.DesignPicture = res.data.design_pics
        }

        // promise_file 承诺书
        if (res.data.promise_file != '') {
          this.promise_file = res.data.promise_file
        }

        // other_file 其他附件
        if (res.data.other_file != '') {
          this.other_file = res.data.other_file
        }

        // 保护类型
        if (res.data.protected_ip_type.length > 0) {
          this.protected_ip_type = res.data.protected_ip_type.split(',')
        }
      }
    },

    //上传
    async uploadInterface(obj, type, fileObj, index) {
      let res = await upload(obj)
      // 身份证复印件
      if (type == 'CopyofIDcard') {
        this.obligees[index].obligee_photo.push({
          url: res.data.url,
          name: fileObj.name
        })
      }
      // 设计图片
      else if (type == 'DesignPicture') {
        this.DesignPicture.push({
          url: res.data.url,
          name: fileObj.name
        })
      }
      // 委托书 powerOfAttorney
      else if (type == 'powerOfAttorney') {
        this.powerOfAttorney.push({
          url: res.data.url,
          name: fileObj.name
        })
      }
          //公正书
          // notarization_file:[],
      else if (type == 'notarization_file') {
        this.notarization_file.push({
          url: res.data.url,
          name: fileObj.name
        })
      }
      // TechnicalDisclosure 技术交底书
      else if (type == 'TechnicalDisclosure') {
        this.TechnicalDisclosure.push({
          url: res.data.url,
          name: fileObj.name
        })
      }

      // promise_file承诺书
      else if (type == 'promise_file') {
        this.promise_file.push({
          url: res.data.url,
          name: fileObj.name
        })
      }
      // other_file 其他附件
      else if (type == 'other_file') {
        this.other_file.push({
          url: res.data.url,
          name: fileObj.name
        })
      }
    },
    SubmitBtn(value, bc) {

      // // 客户没有选择时就删除当前字段// 是否进行过知识产权保护
      // if (this.formdata.is_ip_protected == '') {
      //   this.$delete(this.formdata, 'is_ip_protected')
      // }
      // // 客户没有选择时就删除当前字段 知识产权方式
      // if (this.formdata.ip_mode == '') {
      //   this.$delete(this.formdata, 'ip_mode')
      // }
      //
      // // 客户没有选择时就删除当前字段 技术交底书
      // if (this.formdata.tech_file_type == '') {
      //   this.$delete(this.formdata, 'tech_file_type')
      // }
      // // 客户没有选择时就删除当前字段 经费
      // if (this.formdata.is_research_funds_support == '') {
      //   this.$delete(this.formdata, 'is_research_funds_support')
      // }

      //字段校验
      if (this.formdata.name.length == 0) {
        this.$message({
          type: "error",
          message: "请输入发明名称",
        });
        return;
      }

      if (this.obligees.some((val) => val.obligee_name.length == 0)) {
        this.$message({
          type: "error",
          message: "权利人姓名",
        });
        return;
      }
      if (this.obligees.some((val) => val.obligee_phone.length == 0)) {
        this.$message({
          type: "error",
          message: "权利人联系电话",
        });
        return;
      }

      if (this.obligees.some((val) => val.obligee_email.length == 0)) {
        this.$message({
          type: "error",
          message: "权利人邮箱",
        });
        return;
      }
      if (this.obligees.some((val) => val.obligee_province.length == 0)) {
        this.$message({
          type: "error",
          message: "请选择权利人地址",
        });
        return;
      }
      if (this.obligees.some((val) => val.obligee_city.length == 0)) {
        this.$message({
          type: "error",
          message: "请选择权利人地址",
        });
        return;
      }
      if (this.obligees.some((val) => val.obligee_district.length == 0)) {
        this.$message({
          type: "error",
          message: "请选择权利人地址",
        });
        return;
      }
      if (this.obligees.some((val) => val.obligee_address.length == 0)) {
        this.$message({
          type: "error",
          message: "权利人地址",
        });
        return;
      }
      if (this.obligees.some((val) => val.obligee_photo.length == 0)) {
        this.$message({
          type: "error",
          message: "请上传权利人身份证",
        });
        return;
      }

      if (this.inventors.some((val) => val.inventor_name.length == 0)) {
        this.$message({
          type: "error",
          message: "发明人姓名",
        });
        return;
      }
      if (this.inventors.some((val) => val.inventor_phone.length == 0)) {
        this.$message({
          type: "error",
          message: "发明人联系电话",
        });
        return;
      }
      if (this.inventors.some((val) => val.inventor_email.length == 0)) {
        this.$message({
          type: "error",
          message: "发明人邮箱",
        });
        return;
      }
      // let inventor_IDText = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      // if (this.inventors.some((val) => val.inventor_ID.length != 0 && !inventor_IDText.test(val.inventor_ID))) {
      //   this.$message({
      //     type: "error",
      //     message: "发明人身份证格式不正确",
      //   });
      //   return;
      // }
      let inventor_IDText = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      if (this.inventors.some((val) => !inventor_IDText.test(val.inventor_ID))) {
        this.$message({
          type: "error",
          message: "发明人身份证格式不正确",
        });
        return;
      }
      // inventor_province: '',
      //     inventor_city: '',
      //     inventor_district: ''
      if (this.inventors.some((val) => val.inventor_province.length == 0)) {
        this.$message({
          type: "error",
          message: "请选择发明人地址",
        });
        return;
      }
      if (this.inventors.some((val) => val.inventor_city.length == 0)) {
        this.$message({
          type: "error",
          message: "请选择发明人地址",
        });
        return;
      }
      if (this.inventors.some((val) => val.inventor_district.length == 0)) {
        this.$message({
          type: "error",
          message: "请选择发明人地址",
        });
        return;
      }
      if (this.inventors.some((val) => val.inventor_address.length == 0)) {
        this.$message({
          type: "error",
          message: "发明人地址",
        });
        return;
      }
      if (this.formdata.applicant_name.length == 0) {
        this.$message({
          type: "error",
          message: "请输入申请人姓名",
        });
        return;
      }
      if (this.formdata.applicant_phone.length == 0) {
        this.$message({
          type: "error",
          message: "请输入申请人电话",
        });
        return;
      }
      if (this.formdata.applicant_email.length == 0) {
        this.$message({
          type: "error",
          message: "请输入申请人邮箱",
        });
        return;
      }

      if (this.formdata.applicant_province.length == 0) {
        this.$message({
          type: "error",
          message: "请选择申请人地址",
        });
        return;
      }
      if (this.formdata.applicant_city.length == 0) {
        this.$message({
          type: "error",
          message: "请选择申请人地址",
        });
        return;
      }
      if (this.formdata.applicant_district.length == 0) {
        this.$message({
          type: "error",
          message: "请选择申请人地址",
        });
        return;
      }
      if (this.formdata.applicant_address.length == 0) {
        this.$message({
          type: "error",
          message: "请输入申请人地址",
        });
        return;
      }

      //

      //     // 联系人名字
      //     "contacts_name": '',
      if (this.formdata.contacts_name.length == 0) {
        this.$message({
          type: "error",
          message: "请输入联系人名字",
        });
        return;
      }
      //     // 联系人电话
      //     "contacts_phone": '',
      if (this.formdata.contacts_phone.length == 0) {
        this.$message({
          type: "error",
          message: "请输入联系人电话",
        });
        return;
      }
      //     //联系人 邮箱
      //     "contacts_email": '',
      if (this.formdata.contacts_email.length == 0) {
        this.$message({
          type: "error",
          message: "请输入联系人邮箱",
        });
        return;
      }

      //     //联系人省
      //     "contacts_province": '',
      if (this.formdata.contacts_province.length == 0) {
        this.$message({
          type: "error",
          message: "请选择联系人地址",
        });
        return;
      }

      //     //联系人 市
      //     "contacts_city": '',
      if (this.formdata.contacts_city.length == 0) {
        this.$message({
          type: "error",
          message: "请选择联系人地址",
        });
        return;
      }

      //     // 联系人区
      //     "contacts_district": '',
      if (this.formdata.contacts_district.length == 0) {
        this.$message({
          type: "error",
          message: "请选择联系人地址",
        });
        return;
      }

      //     // 联系人地址
      //     "contacts_address": '',
      if (this.formdata.contacts_address.length == 0) {
        this.$message({
          type: "error",
          message: "请输入联系人地址",
        });
        return;
      }



      //
      // // // 技术交底书性质 1:纸质版 2:电子版
      // // "tech_file_type": null,
      // if (this.formdata.tech_file_type == null) {
      //   this.$message({
      //     type: "error",
      //     message: "请选择技术交底书",
      //   });
      //   return;
      // }
      // if (this.formdata.tech_file_type == 2 && this.TechnicalDisclosure.length == 0) {
      //   this.$message({
      //     type: "error",
      //     message: "请上传技术交底书",
      //   });
      //   return;
      // }
      //
      // //     // 承诺书
      // //     "promise_file": '',
      // // 承诺书 promise_file
      // if (this.promise_file.length == 0) {
      //   this.$message({
      //     type: "error",
      //     message: "请上传承诺书",
      //   });
      //   return;
      // }
      // //     // 是否进行过知识产权保护
      // //     "is_ip_protected": '',
      // if (this.formdata.is_ip_protected.length == 0) {
      //   this.$message({
      //     type: "error",
      //     message: "请选择是否进行过知识产权保护",
      //   });
      //   return;
      // }
      // if(this.protected_ip_type.length<=0 && this.formdata.is_ip_protected == 1){
      //   this.$message({
      //     type: "error",
      //     message: "请选择已保护知识产权类型",
      //   });
      //   return;
      // }
      // //     // 知识产权方式
      // //     "ip_mode": '',
      // if (this.formdata.ip_mode.length == 0) {
      //   this.$message({
      //     type: "error",
      //     message: "请选择知识产权方式",
      //   });
      //   return;
      // }
      // if ((this.formdata.ip_mode== 2 ||this.formdata.ip_mode== 3) && this.powerOfAttorney.length==0) {
      //   this.$message({
      //     type: "error",
      //     message: "请上传收益比例确认书",
      //   });
      //   return;
      // }
      // //公正书
      // // notarization_file:[],
      // if ((this.formdata.ip_mode== 2 ||this.formdata.ip_mode== 3) && this.notarization_file.length==0) {
      //   this.$message({
      //     type: "error",
      //     message: "请上传公正书",
      //   });
      //   return;
      // }
      //
      // //     // 经费
      // //     "is_research_funds_support": '',
      // if (this.formdata.is_research_funds_support.length == 0) {
      //   this.$message({
      //     type: "error",
      //     message: "请选择科研经费支持",
      //   });
      //   return;
      // }
      // //     // 科研项目名称
      // //     "research_project_title": '',
      // if (this.formdata.is_research_funds_support== 0 &&this.formdata.research_project_title.length == 0) {
      //   this.$message({
      //     type: "error",
      //     message: "请输入科研项目名称",
      //   });
      //   return;
      // }





      if (this.isInArray(this.checkList, '3')) {
        if (this.DesignPicture.length == 0) {
          this.$message({
            type: "error",
            message: "请上传设计图片",
          });
          return;
        }
      }
      //
      // 发明者
      this.formdata.inventor = this.inventors
      // 权利者
      this.formdata.obligee = this.obligees
      // `proxy_file`  '代理委托书url',
      this.formdata.proxy_file = this.powerOfAttorney
      //公正书
      // notarization_file:[],
      this.formdata.notarization_file = this.notarization_file

      this.formdata.tech_file = this.TechnicalDisclosure
      this.formdata.design_pics = this.DesignPicture
      this.formdata.promise_file = this.promise_file
      this.formdata.other_file = this.other_file
      this.formdata.protected_ip_type = this.protected_ip_type.join(",")

      if (value == 'add') {
        // 添加
        this.addPatent(bc)
      } else if (value = 'edit') {
        // 修改
        this.modifyPatent(bc)
      }
    },
    // 过滤数组
    isInArray(arr, value) {
      for (var i = 0; i < arr.length; i++) {
        if (value === arr[i]) {
          return true;
        }
      }
      return false;
    },
    // 已保护知识产权类型的数组
    handleCheckAllChange(val) {
      this.formdata.protected_ip_type = val
    },
  }
}
</script>

<style scoped="scoped" lang="less">
.bodyboxinvention {
  width: 63vw;
  margin: 0 auto;
  /*border: 1px red solid;*/
  margin-top: -20px;
  /* border-left: 10px #fff solid; */
  color: #333333;
}

.bodyboxinvention > p {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  /* border: 1px red solid; */
  width: 130px;
  text-align: right;
}

.bodyboxinvention > div {
  // margin-top: 10px;
  // display: flex;
  font-size: 14px;
}

.bodybox_first > div {
  margin-left: 20px;
}

.bodybox_first > div:first-child {
  margin-left: 10px;
}

.bodybox_first > div img {
  vertical-align: middle;
}

.bodyboxinvention .PatentNature {
  margin-top: 10px;
  display: flex;
}

.bodyboxinvention .PatentNature > div {
  line-height: 28px;
  margin-right: 20px;

}

.bodyboxinvention .PatentNature > div > .inputbox {
  width: 164px;
  height: 28px;
  border-radius: 5px;
  // border: 1px solid #E5E5E5;
  line-height: 28px;
  // padding-left: 4px;
  color: #A0A0A0;
  font-size: 14px;

}

/deep/ .el-input__inner {
  height: 100%;
}

/deep/ .el-input {
  height: 100%;
  display: block;
}

/deep/ .el-textarea__inner {
  height: 100% !important;
}

.bodyboxinvention .applicant {
  line-height: 28px;
  // margin-right: 20px;
  margin-top: 10px;
  display: flex;
}

.bodyboxinvention .applicant > .inputbox {
  width: 54vw;
  height: 28px;
  border-radius: 5px;
  // border: 1px solid #E5E5E5;
  // padding-left: 4px;
  color: #A0A0A0;
  font-size: 14px;
}

.bodyboxinvention .business > div {
  margin-top: 10px;
  display: flex;
}

.bodyboxinvention .business > div > .bodybox_first {
  width: 26vw;
  height: 30vh;
  border-radius: 5px;
  border: 1px solid #E5E5E5;
}

.bodyboxinvention .business > div > .bodybox_first {
  position: relative;

}

.bodyboxinvention .business > div > .bodybox_first img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.bodyboxinvention .business > div:nth-child(2) > .title {
  width: 7vw;
  /* margin-left: 25px; */
}

.bodyboxinvention .technology {
  line-height: 28px;
  margin-top: 10px;
  display: flex;
}

.bodyboxinvention .technology .inputbox {
  width: 72px;
  height: 28px;
  border-radius: 5px;
  border: 1px solid #E5E5E5;
  line-height: 28px;
  padding-left: 4px;
  color: #A0A0A0;
  font-size: 14px;


}

.bodyboxinvention .technology .enclosure {
  color: #7CBDF8;
  line-height: 28px;
  padding-left: 6px;
  float: left;
}

 .enclosure1 {
   a{
     color: #079428;

   }
  color: #079428;
  line-height: 28px;
  padding-left: 6px;
  float: left;
}

.bodyboxinvention .technology .enclosure > img {
  vertical-align: middle;
}

.bodyboxinvention .technology .enclosure1 > img {
  vertical-align: middle;
}

.bodyboxinvention .explain {
  margin-top: 10px;
  display: flex;
}

.bodyboxinvention .explain > .inputbox {
  width: 17vw;
  height: 17vh;
  background: #D8D8D8;
  border-radius: 5px;
}

.bodyboxinvention .explain > .explainbox {
  width: 39vw;
  height: 17vh;
  border-radius: 5px;
  // border: 1px solid #E5E5E5;
  margin-left: 10px;
  color: #E5E5E5;

  /deep/ .el-textarea {
    height: 100% !important;
  }
}

/deep/ .el-radio {
  font-weight: 400 !important;
}

/deep/ .el-checkbox {
  font-weight: 400 !important;
}

.btnbox {
  text-align: center;
}

.tjbtn {
  width: 11.8vw;
  height: 5vh;
  background: #0D68BB;
  border-radius: 5px;
  // margin: 0 auto;
  margin-top: 30px;
  color: #FFFFFF;
  font-weight: bolder;
  line-height: 5vh;
  text-align: center;
  display: inline-block;
  font-size: 1.3rem !important;

  span {
    text-align: center;
    width: 227px;
  }
}

.bcbtn {
  width: 11.8vw;
  height: 5vh;
  background: #0CA14E;
  border-radius: 5px;
  border-radius: 5px;
  // margin: 0 auto;
  margin-top: 30px;
  color: #FFFFFF;
  font-weight: bolder;
  line-height: 5vh;
  text-align: center;
  display: inline-block;
  font-size: 1.3rem !important;
  margin-right: 2vw;

  span {
    text-align: center;
    width: 227px;
  }
}


.title {
  //width: 9vw;
  //text-align: right;
}

.inputboxone {
  width: 164px;
  height: 28px;
  border-radius: 5px;
  border: 1px solid #E5E5E5;
  line-height: 28px;
  padding-left: 4px;
  color: #A0A0A0;
  font-size: 14px;
  background: #E5E5E5;
}

.title {
  line-height: 28px;
}

.boxinp {
  width: 16px;
  height: 16px;
  color: #ffffff;
  background: #C91111;
  text-align: center;
  line-height: 16px;
  border-radius: 50%;
  font-size: 0.3rem;
}
.buj{
  //width: 8.3vw;
  ////border: 1px red solid;
  //display: flex;
  //justify-content: right;
  //margin-right: 10px;
}
.jee {
  background: #005E3A;
  border-radius: 2px;
  width: 2.8vw;
  height: 2.5vh;
  text-align: center;
  line-height: 2.5vh;
  color: #FFFFFF;
  font-size: 0.87rem;
}

.hrr {
  width: 100%;
  height: 0.9vh;
  background: #E5E5E5;
  opacity: 0.46;
  margin-top: 2vh;
}

.hrr1 {
  width: 100%;
  height: 0.2vh;
  background: #E5E5E5;
  opacity: 0.46;
  margin-top: 2vh;
}

.research_project_titlebox {
  border-bottom: 1px #ccc solid;
  // margin-left: 1vw;
  margin-right: 1vw;
}

.research_project_titlebox input {
  border: none;
  outline: none;
}

// 省市区的样式
/deep/ .distpicker-address-wrapper select {
  width: 164px;
  height: 28px;
  border-radius: 5px;
  line-height: 28px;
  padding: 0;
  font-size: 0.73rem;

}


/deep/.el-input__icon {
  line-height: 28px;
}
</style>
